import React from "react";
import {useCollapse} from "react-collapsed";
import translate from "components/translations/translations.wrapper";
import NotificationsContent from "components/newSettings/Settings.notifications.content";

export const Notifications = ({...props}: any): React.ReactElement => {

    const {getCollapseProps, getToggleProps} = useCollapse();

    return <div>
        <div {...getToggleProps()} className={"p-16"}>
            <h3>{props.translate("settings.approverNotifications")}</h3>
            <div>{props.translate("settings.notificationsMoreInfo")}</div>
        </div>
        <section {...getCollapseProps()} className={"mt-4 py-16"}>
            <NotificationsContent/>
        </section>
    </div>
}

const withTranslations = translate(Notifications);
export default withTranslations;